import styled from "styled-components";

import { color } from "../../theme/color";

/** A row in the setlist or songs slide-over. The open one has `aria-current`. */
export const MenuRow = styled.button<{ $indent?: boolean }>`
    width: 100%;
    min-height: 52px;
    padding: 8px 12px 8px ${({ $indent }) => ($indent ? "36px" : "12px")};
    display: flex;
    align-items: center;
    gap: 10px;
    border: 0;
    border-radius: 12px;
    background: transparent;
    color: ${color.text};
    text-align: left;
    font-size: 15px;
    cursor: pointer;

    &[aria-current="true"] {
        background: ${color.accentSoft};
        color: ${color.accent};
    }
`;

export const MenuList = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
`;

/** A link at the bottom of a slide-over. */
export const MenuLink = styled.button`
    min-height: 44px;
    padding: 0;
    border: 0;
    background: transparent;
    color: ${color.accent};
    font-size: 15px;
    font-weight: 600;
    text-align: left;
    cursor: pointer;
`;
